

const orgDropdown = document.querySelector('.js-account-organisation');
const addressDropdown = document.querySelector('.js-organisation-address');

function createOption(text, value) {
    var option = document.createElement("option");
    option.text = text;
    option.value = value;

    return option;
}

orgDropdown.addEventListener('change', () => {

    if (addressDropdown == null) {
        return;
    }

    const value = orgDropdown.value;
    addressDropdown.innerHTML = '';
    addressDropdown.appendChild(createOption('Select an address', ''));

    fetch(`/Umbraco/Surface/OrganisationAddress/GetAddresses?orgId=${value}`, {
        method: 'GET'
    }).then(function (response) {
        return response.json();
    }).then(data => {
        if (data) {
            if (data.length) {
                data.forEach((address) => {
                    var label = address.Line1;

                    if (address.Line2) {
                        label = address.Line1 + ", " + address.Line2;
                    }

                    if (address.City) {
                        label = label + ". " + address.City;
                    }

                    if (address.PostCode) {
                        label = label + ". " + address.PostCode;
                    }

                    var option = createOption(label, address.AddressId);

                    addressDropdown.appendChild(option);
                });
            }
        }
    }).catch(function (err) {
        console.warn('Something went wrong.', err);
    });
})